export default class RequestSoftwareModalController {
  constructor(Task) {
    'ngInject';

    this.Task = Task;
  }

  handleAccept(task) {
    return this.Task.accept({}, task).$promise
      .then((response) => {
        this.onActionSubmit({task: response.task});
        this.closeModal();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/components/accept-modal/accept-modal.controller.js